// Digital graphs must must be at least a certain height to ensure all types of hairlines display correctly when
// it contains only one channel.
export const DIGITAL_GRAPH_MIN_HEIGHT = 200;
